import React, {useEffect} from "react";
import Navbar from "../components/Nav";
import Details from "../components/Details";
import Stats from "../components/Stats";
import { useDispatch } from 'react-redux';
import { fetchUserData } from '../redux/userSlice';

const ProfileContent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserData());
  }, [dispatch]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <div className="flex flex-col md:flex-row ">
        <div className="w-full md:w-1/2 h-0.7 md:h-full ">
          <Details />
        </div>
        <div className="w-full md:w-1/2 h-0.7 md:h-full bg-red-600 ">
          <Stats />
        </div>
      </div>
    </div>
  );
};

const Profile = () => {
  return (
    <ProfileContent />
);}

export default Profile;
